import React from "react";

const Money = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12.31 11.14C10.54 10.69 9.97 10.2 9.97 9.47C9.97 8.63 10.76 8.04 12.07 8.04C13.45 8.04 14.23 8.7 14.37 9.8H16.21C16.06 8.17 14.99 6.82 13.06 6.43V5H11.07V6.41C9.24 6.72 7.79 7.81 7.79 9.5C7.79 11.46 9.32 12.47 11.57 13.01C13.59 13.5 14 14.17 14 14.92C14 15.45 13.63 16.32 12.07 16.32C10.62 16.32 9.69 15.73 9.5 14.63H7.64C7.85 16.46 9.27 17.64 11.08 17.95V19H13.07V17.96C14.92 17.67 16.18 16.71 16.18 14.9C16.18 12.47 14.07 11.59 12.31 11.14Z"
        fill="#3A383F"
      />
    </svg>
  );
};

export default Money;